import { Evento } from '../../types/Evento';
import { Slide } from './Slide';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export const Slider = (props: { eventos: Evento[] }) => {
  if (props.eventos === null) return <></>;

  return (
    <Swiper
      className="swiper"
      modules={[Autoplay, Navigation, Pagination]}
      navigation
      autoplay={{
        delay: 2500,
        disableOnInteraction: true,
      }}
      spaceBetween={30}
      pagination={{ clickable: true }}
      loop={props.eventos.length > 1 ? true : false}
    >
      {props.eventos.map((item, index) => {
        return (
          <SwiperSlide key={index} style={{ paddingBottom: '0px' }}>
            <Slide evento={item} />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};
